/**
 * School subdomain detection utilities.
 *
 * School URLs: schoolSlug.ithopu.com (e.g., modern.ithopu.com)
 * Main site: ithopu.com, www.ithopu.com, app.ithopu.com, localhost
 */

export function getSchoolSlug(): string | null {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  // e.g., "modern.ithopu.com" → ["modern", "ithopu", "com"]
  if (parts.length >= 3 && parts[1] === "ithopu") {
    const slug = parts[0];
    if (!["www", "app", "api", "admin", "mail"].includes(slug)) {
      return slug;
    }
  }

  // Dev: check for school slug in localStorage (for local testing)
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return localStorage.getItem("__dev_school_slug") || null;
  }

  return null;
}

export function isSchoolMode(): boolean {
  return getSchoolSlug() !== null;
}

export function buildSyntheticEmail(userId: string, slug: string): string {
  return `${userId.toLowerCase()}@${slug}.ithopu.com`;
}
